/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function transformListing(priceHolder) {
        if (priceHolder.classList.contains('transformed')) {
            return;
        }

        priceHolder.classList.add('transformed');

        if (!document.documentElement.classList.contains('w57')) {
            document.documentElement.classList.add('w57');
        }

        var listing = priceHolder.closest('.grid-product');
        if (!listing) {
            console.error('Listing element not found for priceHolder:', priceHolder);
            return;
        }

        var childNodes = priceHolder.childNodes;
        var currentPriceNode, currentPrice, newPriceNode;

        for (var i = childNodes.length - 1; i >= 0; i--) {
            if (childNodes[i].nodeType !== Node.TEXT_NODE) {
                continue;
            }

            if (childNodes[i].textContent.indexOf('$') >= 0) {
                currentPriceNode = childNodes[i];
                break;
            }
        }

        if (currentPriceNode) {
            currentPrice = currentPriceNode.textContent.replace('from', '').trim();
            newPriceNode = document.createElement('span');
            newPriceNode.className = 'price-current';
            newPriceNode.innerHTML = currentPrice;

            currentPriceNode.replaceWith(newPriceNode);
        }

        var ratingNode = listing.querySelector('.okeReviews');
        if (ratingNode) {
            var ratingHolder = document.createElement('div');
            ratingHolder.className = 'rating-holder';
            ratingHolder.innerHTML = `
                <span class="rate-star"></span>
                ${ratingNode.querySelector('.oke-sr-rating').innerHTML}
                <span>(${ratingNode.querySelector('.oke-sr-count-number').innerHTML})</span>
            `;

            priceHolder.insertAdjacentElement('beforebegin', ratingHolder);
        }
    }

    Mojito.utils.observeSelector('.grid-product .grid-product__price', function (e) {
        transformListing(e);
    });
})();
